import React from 'react';
import PropTypes from 'prop-types';

import { MapContext, MapContextProvider } from './map';
import { ConfigContext, ConfigProvider } from './config';

export { MapContext, ConfigContext };

export function ContextProvider(props) {
  return (
    <ConfigProvider>
      <MapContextProvider>
        {props.children}
      </MapContextProvider>
    </ConfigProvider>
  );
}

ContextProvider.propTypes = {
  children: PropTypes.node,
};
